import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const TalkBoxService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getConversation = (conversationId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/v2/conversation/${conversationId}`, {
      headers,
    });
  };

  const conversationSearch = (conversationSearchRequest) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const {
      customerId = '', beginRange = '', endRange = '', limit = '', offset = '',
    } = conversationSearchRequest;

    return axios.get(
      `${BASE_URL}/v2/conversation?customerId=${customerId}&beginRange=${beginRange}&endRange=${endRange}&limit=${limit}&offset=${offset}`,
      {
        headers,
      }
    );
  };

  service.getConversation = getConversation;
  service.conversationSearch = conversationSearch;

  return service;
})();

export default TalkBoxService;
